import { Component, ReactNode, ErrorInfo } from 'react';

import { ReactRenderingError } from 'errors/ReactRenderingError';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ hasError: true });

    return new ReactRenderingError({ error, errorInfo });
  }

  render() {
    return this.state.hasError ? (
      <p>The application is temporarily unavailable</p>
    ) : (
      this.props.children
    );
  }
}
